import React from 'react';


import Step0Adult from './adult/step0';
import Step1Adult from './adult/step1';
import Step2Adult from './adult/step2';
import Step3Adult from './adult/step3';
import Step4Adult from './adult/step4';
import Step5Adult from './adult/step5';
import ResultsAdult from './adult/results';

import Step0Child from './child/step0';
import Step1Child from './child/step1';
import Step2Child from './child/step2';
import Step3Child from './child/step3';
import Step4Child from './child/step4';
import Step5Child from './child/step5';
import Step6Child from './child/step6';
import Step7Child from './child/step7';
import ResultsChild from './child/results';

const Test = (props)=> {
		let Steps;
		let Results;
		if(props.role === "adult"){
			Steps = [Step0Adult, Step1Adult, Step2Adult, Step3Adult, Step4Adult, Step5Adult];
			Results = ResultsAdult;
		}else{
			Steps = [Step0Child, Step1Child, Step2Child, Step3Child, Step4Child, Step5Child, Step6Child, Step7Child];
			Results = ResultsChild;
		}
		const Tag = Steps[props.step];
		if(props.step<Steps.length){
			return(
				<section className={props.role} data-step={props.step}>
					<div className="content-container">
						<div className="col-xs-12">
							<div className="borderOuterContainer">
								<div className="borderInnerContainer">
									<Tag restartHandler={props.restartHandler} prevHandler={props.prevHandler} answerHandler={props.answerHandler} formHandler={props.formHandler} name={"step"+props.step} TempScore={props.TempScore} step={props.step} steps={Steps.length} role={props.role} />
								</div>
							</div>
						</div>
					</div>
				</section>		
			)
		}else{
			return(
				<Results Score={props.Score} printHandler={props.printHandler} role={props.role} />
			)
		}
}

export default Test;
